import AvailabilityBadge from "./AvailabilityBadge";

export default AvailabilityBadge;
